module.exports = __webpack_public_path__ + "img/xiaozi_quanlianlu.d10f38c6.png";